import _ from 'lodash';

export function levelElasticityDriverParser(data: any) {
    const resultArray: any[] = [];
    const newResult: any = {
        minBound: Infinity,
        maxBound: 0,
        maxCharacters: 0, //calculating the length of word with max characters to determine height of row
        data: [],
    };

    data?.forEach((item: any) => {
        let tempObj: any = {};
        for (let key in item) {
            tempObj[key] = typeof item[key] === 'number' ? _.round(item[key], 2) : item[key];
        }

        // if internal or external elasticities are positive then we have to negate their signs
        if (tempObj.externalCompetitorElasticity > 0) tempObj.externalCompetitorElasticity *= -1;
        if (tempObj.internalCompetitorElasticity > 0) tempObj.internalCompetitorElasticity *= -1;

        // adding items
        let aggregate = 0;
        for (let key in tempObj) {
            const baseResult: any = { category: tempObj['attributeName'] };
            newResult.maxCharacters = Math.max(newResult.maxCharacters, tempObj['attributeName']?.length || 0);

            if (key === 'ownElasticity') {
                baseResult['type'] = 'Own Elasticity';
                baseResult['categoryAttribute'] = 'Own Elasticity';
                baseResult['value'] = tempObj.ownElasticity;
                aggregate += tempObj.ownElasticity;
                resultArray.push(baseResult);
            } else if (key === 'internalCompetitorElasticity') {
                baseResult['type'] = 'Internal Competitor Elasticity';
                baseResult['categoryAttribute'] = 'Internal Competitor Elasticity';
                baseResult['value'] = tempObj.internalCompetitorElasticity;
                aggregate += tempObj.internalCompetitorElasticity;
                resultArray.push(baseResult);
            } else if (key === 'externalCompetitorElasticity') {
                baseResult['type'] = 'External Competitor Elasticity';
                baseResult['categoryAttribute'] = 'External Competitor Elasticity';
                baseResult['value'] = tempObj.externalCompetitorElasticity;
                aggregate += tempObj.externalCompetitorElasticity;
                resultArray.push(baseResult);
            }
        }
        const baseResult: any = { category: tempObj['attributeName'] };
        baseResult['type'] = 'Total Elasticity';
        baseResult['categoryAttribute'] = 'Total Elasticity';
        baseResult['value'] = _.round(aggregate, 2);
        newResult.minBound = Math.min(newResult.minBound, baseResult['value']);
        resultArray.push(baseResult);
    });

    newResult.data = mergeByCategory(resultArray);
    return newResult;
}

// Function to merge based on category
const mergeByCategory = (data: any) => {
    const result: any[] = [];
    const categoryMap: any = {};

    data.forEach((item: any) => {
        if (!categoryMap[item.category]) {
            categoryMap[item.category] = {
                category: item.category,
                attributes: [],
            };
            result.push(categoryMap[item.category]);
        }
        categoryMap[item.category].attributes.push({
            type: item.type,
            categoryAttribute: item.categoryAttribute,
            value: item.value,
            category: item.category,
        });
    });

    return result;
};
